import { reduxSetter } from '../../../../utils/reduxSetter';
import { SET_MODAL_WINDOW_DATA, CLOSE_MODAL_WINDOW } from '../constants/modalWindow.constants';

const initialState = () => ({
    isLoading: false,
    isOpen: false,
    error: null,
    maxWidth: 'md',
    content: {
        header: null,
        body: null,
        footer: null,
    },
    onSave: () => {},
    onClose: () => {},
});

export const modalWindow = (state = initialState(), action) => {
    switch (action.type) {
    case SET_MODAL_WINDOW_DATA:
        return reduxSetter(state, action);
    case CLOSE_MODAL_WINDOW:
        return initialState();
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/App/redux/reducers/modalWindow.reducer.js